import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TriangleDownComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__triangleDown"
      width={size}
      height={size}
      viewBox="0 0 6 5"
      fill="none"
    >
      <path d="M3 5L0.401923 0.5L5.59808 0.500001L3 5Z" fill={colorVar} />
    </svg>
  );
};

export const TriangleDown = withIcon(TriangleDownComponent);
